import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import UnlimitedCtaDecor from 'assets/images/decors/relaxDecor.svg'
import { respondBelow, respondAbove } from 'styles/mediaQueries'
import Text from 'components/shared/Text'

export const UnlimitedCtaBox = styled(Box)`
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    background: url(${UnlimitedCtaDecor}),
        ${({ theme }) => theme.colors.darkmode_900};
    background-position: 125px 18px;
    background-repeat: no-repeat;
    border-radius: 9px;
    text-align: center;
    min-height: 356px;
    @media ${respondBelow.xl} {
        align-items: flex-start;
        justify-content: center;
        padding-right: 76px;
        background-size: 140px auto;
        background-position: calc(100% + 10px) calc(100% + 23px);
        text-align: left;
        min-height: 116px;
    }
    @media ${respondAbove.xl} {
        position: sticky;
        top: 24px;
        margin-bottom: 244px;
    }
    ${Text} {
        span {
            color: ${({ theme }) => theme.colors.grayscale_0};
        }
    }

    @media ${respondBelow.xl} {
        a {
            span {
                position: absolute;
                right: 16px;
                top: 50%;
                transform: translateY(-50%);
                content: '';
                display: flex;
                align-items: center;
                justify-content: center;
                width: 44px;
                height: 44px;
                border-radius: 500px;
                border: 2px solid ${({ theme }) => theme.colors.primary_500};
            }
            ::before {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                display: block;
                content: '';
            }
        }
    }
`

export const UnlimitedCtaTop = styled(Box)`
    justify-content: center;
    align-items: center;
    img {
        width: 100%;
        padding: 12px 34px;
    }
    @media ${respondBelow.xl} {
        align-items: flex-start;
        img {
            max-width: 46px;
            margin-right: 16px;
            padding: 0;
        }
    }
`
